// Wide photos used as faded page backgrounds: the hub hero and the generic
// page headers. Put the files in client/public/backgrounds/ (WebP, about
// 1920px wide, under ~300 KB) and list them here. Slots left empty fall back
// to generated art.
//
// Current images are Predecessor art (Omeda Studios) with the game logo
// cropped out, so the site never looks official. The footer carries the
// not-affiliated notice.
export const BACKGROUNDS = {
  // Shown from its left edge (the owner's choice), so the warrior's spear arm
  // sits behind the hero text, under a lighter scrim.
  hero: [{ src: '/backgrounds/spear-warrior.webp', position: '0% 30%' }],
  pages: [
    { src: '/backgrounds/arena-clash.webp', position: 'center 35%' },
    { src: '/backgrounds/jungle-ruins.webp', position: 'center 40%' },
    { src: '/backgrounds/city-lane.webp', position: 'center 45%' },
  ],
}

function hash(text) {
  let h = 0
  for (const ch of String(text)) h = (h * 31 + ch.charCodeAt(0)) >>> 0
  return h
}

// Picks the same image for the same seed every time.
export function pickBackground(slot, seed = '') {
  const list = BACKGROUNDS[slot] ?? []
  return list.length ? list[hash(seed) % list.length] : null
}
